<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30.748"
    height="21.575"
    viewBox="0 0 30.748 21.575"
  >
    <g transform="translate(-7274.715 -711.75)">
      <g transform="translate(7275 714.683)">
        <path
          class="a"
          :fill="color"
          d="M447.726,454.507h-18.12a.332.332,0,0,1-.328-.282c-.017-.115-.4-2.82,1.349-4.065a6.344,6.344,0,0,1,2.374-.872,4.759,4.759,0,0,0,3.153-1.626c.009-.012.342-.521-.706-1.8-1.683-2.057-1.3-5.309-1.14-6.257a4.466,4.466,0,0,1,8.715,0c.158.948.543,4.2-1.14,6.257-1.048,1.281-.715,1.79-.711,1.795a4.762,4.762,0,0,0,3.159,1.633,6.346,6.346,0,0,1,2.375.872c1.751,1.245,1.366,3.951,1.349,4.065A.332.332,0,0,1,447.726,454.507Zm-17.819-.663h17.517c.042-.667.023-2.343-1.1-3.143a5.772,5.772,0,0,0-2.133-.765,5.422,5.422,0,0,1-3.539-1.874c-.061-.067-.7-.883.721-2.621,1.507-1.841,1.146-4.85,1-5.728a3.8,3.8,0,0,0-7.407,0c-.146.878-.507,3.887,1,5.728,1.422,1.738.782,2.555.7,2.642a5.408,5.408,0,0,1-3.522,1.853,5.771,5.771,0,0,0-2.134.765C429.881,451.5,429.864,453.177,429.907,453.843Z"
          transform="translate(-429.23 -436.115)"
        />
      </g>
      <path
        class="a"
        :fill="color"
        d="M804.872,373.159a6.344,6.344,0,0,0-2.374-.872,4.762,4.762,0,0,1-3.159-1.633c0-.005-.337-.514.711-1.795,1.683-2.057,1.3-5.31,1.141-6.257a4.466,4.466,0,0,0-8.715,0c-.158.948-.543,4.2,1.14,6.257,1.048,1.281.714,1.79.705,1.8a4.759,4.759,0,0,1-3.153,1.626,6.345,6.345,0,0,0-2.374.872q-.1.068-.182.141a2.979,2.979,0,0,0,.51.442l.056-.043a5.771,5.771,0,0,1,2.134-.765,5.409,5.409,0,0,0,3.522-1.853c.078-.088.718-.9-.7-2.642-1.506-1.841-1.146-4.85-1-5.728a3.8,3.8,0,0,1,7.407,0c.146.878.507,3.887-1,5.728-1.422,1.738-.782,2.555-.721,2.621a5.422,5.422,0,0,0,3.539,1.874,5.772,5.772,0,0,1,2.134.765c1.126.8,1.145,2.476,1.1,3.143H794.965a4.452,4.452,0,0,1,.247.664h10.68a.332.332,0,0,0,.328-.283C806.238,377.11,806.623,374.4,804.872,373.159Z"
        transform="translate(6498.912 352.885)"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'TwoPeople',
    props: {
      color: {
        type: String,
        default: '#383935',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 30.748px;
    height: 21.575px;
  }
</style>
